<template>
  <v-container fluid class="pa-0 save-date-container">
    <!-- 💖 Floating animated hearts background -->
    <div class="hearts-bg">
      <div v-for="n in 15" :key="n" class="heart" :style="randomStyle(n)"></div>
    </div>
    <canvas ref="confettiCanvas" class="confetti-canvas"></canvas>
    <!-- Header -->
    <div class="title-section">
      <h1 class="script-font">Save the date</h1>
    </div>

    <!-- Photos with date -->
    <div class="date-photos">
      <div class="photo-card" :class="i === 0 ? 'photo-card_1' : i === 1 ? 'photo-card_2' : 'photo-card_3'"
        v-for="(img, i) in images" :key="i">
        <v-img :src="img.src" :height="photoHeight" cover></v-img>
        <div class="date-overlay">{{ img.text }}</div>
      </div>
    </div>

    <!-- Names -->
    <div class="names">
      <h2 class="names-text">Ojasvi & Daksh</h2>
    </div>

    <!-- Countdown -->
    <div class="countdown">
      <div v-for="(value, key) in countdown" :key="key" class="countdown-item">
        <div class="count">{{ value }}</div>
        <div class="label">{{ key }}</div>
      </div>
    </div>
    <div class="footer">
      <h4 class="script-font_2">#DakshVi</h4>
    </div>
  </v-container>
</template>

<script>
import confetti from "canvas-confetti";
export default {
  name: "SaveTheDate",
  data() {
    return {
      confettiInstance: null,
      targetDate: new Date("2025-11-09T19:00:00"),
      countdown: { Days: 0, Hours: 0, Minutes: 0, Seconds: 0 },
      images: [
        { src: require("@/assets/images/image_1.jpg"), text: "09" },
        { src: require("@/assets/images/image_2.jpg"), text: "11" },
        { src: require("@/assets/images/image_3.jpg"), text: "25" },
      ],
      windowWidth: window.innerWidth,
      heartInterval: null,
    };
  },
  computed: {
    photoHeight() {
      return this.windowWidth < 600 ? "150px" : "400px";
    },
  },
  mounted() {
    this.updateCountdown();
    setInterval(this.updateCountdown, 1000);
    window.addEventListener("resize", this.handleResize);
    // 💖 Initialize confetti
    const canvas = this.$refs.confettiCanvas;
    this.confettiInstance = confetti.create(canvas, { resize: true, useWorker: true });

    // 🎉 Auto-floating confetti in background
    this.confettiInterval = setInterval(() => {
      this.confettiInstance({
        particleCount: 5,
        spread: 70,
        startVelocity: 20,
        origin: { x: Math.random(), y: Math.random() - 0.2 },
        colors: ["#ff6b81", "#ff8fa3", "#ffb3c6", "#ff7f50", "#ff9aa2"],
        scalar: 1.2,
      });
    }, 500);
    // 💖 Start floating hearts
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.heartInterval) clearInterval(this.heartInterval);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    randomStyle(n) {
      const left = Math.random() * 100;
      const delay = Math.random() * 1; // slightly staggered start
      const size = 12 + Math.random() * 20;
      const duration = 12 + Math.random() * 20; // 💖 slower float speed
      const opacity = 0.3 + Math.random() * 0.7;
      const colorChoices = ["#DC143C", "#E0115F", "#FF4040", "#C21E56"];
      const color = colorChoices[n % colorChoices.length];
      return {
        left: `${left}%`,
        animationDelay: `${delay}s`,
        animationDuration: `${duration}s`,
        width: `${size}px`,
        height: `${size}px`,
        background: color,
        opacity,
      };
    },
    updateCountdown() {
      const now = new Date().getTime();
      const distance = this.targetDate - now;
      if (distance <= 0) {
        this.countdown = { Days: 0, Hours: 0, Minutes: 0, Seconds: 0 };
        return;
      }
      this.countdown.Days = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.countdown.Hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
      this.countdown.Minutes = Math.floor((distance / (1000 * 60)) % 60);
      this.countdown.Seconds = Math.floor((distance / 1000) % 60);
    },


  },
};
</script>

<style scoped>
.save-date-container {
  background-color: #f1d7d7;
  background-image: url('../assets/images/back_g.png');
  background-size: cover;
  overflow: hidden;
  position: relative;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.hearts-bg {
  width: 100%;
  transform: rotate(180deg);
}

.heart {
  position: absolute;
  bottom: -20px;
  width: 18px;
  height: 18px;
  background: #dc143c;
  transform: rotate(45deg);
  /* 👈 This rotation makes the shape a perfect heart */
  animation: floatUp linear infinite, shimmer 3s ease-in-out infinite alternate;
  filter: drop-shadow(0 0 8px rgba(255, 100, 120, 0.6));
  box-shadow: 0 0 12px rgba(255, 80, 100, 0.5);
  transform-origin: center;
  opacity: 0;
}

.heart::before,
.heart::after {
  content: "";
  position: absolute;
  width: 18px;
  height: 18px;
  background: inherit;
  border-radius: 50%;
}

/* 👇 circle positions to form top lobes of the heart */
.heart::before {
  top: -9px;
  left: 0;
}

.heart::after {
  left: 9px;
  top: 0;
}

/* 🌬️ Smooth float animation */
@keyframes floatUp {
  0% {
    transform: translateY(0) rotate(45deg) scale(1);
    opacity: 1;
  }

  25% {
    transform: translateY(-30vh) rotate(45deg) scale(1.1);
    opacity: 0.9;
  }

  50% {
    transform: translateY(-60vh) rotate(45deg) scale(1.05);
    opacity: 0.8;
  }

  75% {
    transform: translateY(-90vh) rotate(45deg) scale(1);
    opacity: 0.6;
  }

  100% {
    transform: translateY(-120vh) rotate(45deg) scale(0.9);
    opacity: 0;
  }
}

/* ✨ Shimmer effect */
@keyframes shimmer {
  0% {
    filter: drop-shadow(0 0 6px rgba(255, 100, 120, 0.3));
  }

  50% {
    filter: drop-shadow(0 0 16px rgba(255, 120, 140, 0.8));
  }

  100% {
    filter: drop-shadow(0 0 6px rgba(255, 100, 120, 0.3));
  }
}


.heart::before,
.heart::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: inherit;
  border-radius: 50%;
}

.heart::before {
  top: 0;
  left: 50%;
}

.heart::after {
  left: 0;
  top: 50%;
}


/* Content above hearts */
.title-section,
.date-photos,
.names,
.countdown {
  position: relative;
  z-index: 2;
}

/* --- Your existing styles below --- */

.title-section {
  text-align: center;
  margin-bottom: 20px;
}

.script-font {
  font-family: "Great Vibes", cursive;
  font-size: 48px;
  color: #1a1a1a;
}

.script-font_2 {
  font-family: "Great Vibes", cursive;
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(45deg,
      #FF6EC4,
      #E63946,
      #9D4EDD);
  background-size: 300% 300%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: loveGradient 6s ease infinite;
  position: relative;
}

/* Adds reflective gloss effect */
.reflective-love::after {
  content: '';
  position: absolute;
  top: 0;
  left: -75%;
  width: 50%;
  height: 100%;
  background: linear-gradient(120deg,
      rgba(255, 255, 255, 0.6) 0%,
      rgba(255, 255, 255, 0) 80%);
  transform: skewX(-20deg);
  animation: loveShine 3s infinite;
}

/* Gradient shimmer animation */
@keyframes loveGradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

/* Reflective shine animation */
@keyframes loveShine {
  0% {
    left: -75%;
  }

  50% {
    left: 125%;
  }

  100% {
    left: 125%;
  }
}

.date-photos {
  width: 90%;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.footer {
  margin-top: 5px;
}

.photo-card {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  flex: 1 1 calc(33.33% - 10px);
  min-width: 100px;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.photo-card:hover {
  transform: scale(1.05);
  z-index: 2;
  box-shadow: 0 20px 30px rgba(0, 0, 0, 0.3);
}

.date-overlay {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  font-size: 48px;
  font-weight: bold;
  color: white;
  background: rgba(0, 0, 0, 0.3);
  font-family: "Playfair Display", serif;
}

.names {
  margin-top: 10px;
  text-align: center;
}

.names-text {
  font-family: "Playfair Display", serif;
  font-size: 32px;
  letter-spacing: 2px;
  color: #1a1a1a;
}

.countdown {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
}

.countdown-item {
  text-align: center;
  min-width: 70px;
}

.count {
  font-size: 36px;
  font-weight: bold;
  color: #333;
}

.label {
  font-size: 14px;
  color: #777;
}

/* 📱 Responsive */
@media (max-width: 600px) {
  .script-font {
    font-size: 34px;
  }

  .date-overlay {
    font-size: 32px;
  }

  .names-text {
    font-size: 22px;
  }

  .count {
    font-size: 26px;
  }
}
</style>
